import { gql } from '@apollo/client';

const GET_PRODUCTS = gql`
  query products($params: QueryParams, $name: String) {
    products(params: $params, name: $name) {
      info {
        count
      }
      results {
        id
        name
        description
        type
        variants {
          id
          title
          img
          description
          price
          isPrimaryVariant
          product {
            id
            name
            description
          }
        }
      }     
    }
  }
`;

const UPDATE_BANNER = gql`
  mutation updateBanner($id: ID!, $banner: BannerUpdateInput!) {
    updateBanner(id: $id, banner: $banner) {
      id
    }
  }
`;

export { GET_PRODUCTS, UPDATE_BANNER }
